import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    titulo: { paddingBottom: 0 },
});

export default useStyles;
